import { useApiClient } from '@/composables/useApiClient'
import type {
  IAiCreditBalanceResponse,
  IAiTenantSummaryResponse,
} from '@/services/ai/interfaces/ai-credit.interface'

export const useAiService = () => {
  const privateApi = useApiClient(true)

  const getPlatformCredits = () => privateApi.get<IAiCreditBalanceResponse>('/ai/credits')
  const getTenantSummary = () => privateApi.get<IAiTenantSummaryResponse>('/ai/summary')

  return { getPlatformCredits, getTenantSummary }
}
